import React from "react";
import { css } from "@emotion/react";

import { CSS_MQ } from "../../../styles/breakpoints";
import { FooterConfiguration } from "@swo/storefront";

const YoutubeIcon = "/assets/social-icons/youtube.svg";
const InstagramIcon = "/assets/social-icons/instagram.svg";
const FacebookIcon = "/assets/social-icons/facebook.svg";
const PinterestIcon = "/assets/social-icons/pinterest.svg";
const LinkedInIcon = "/assets/social-icons/linkedin.svg";
const XIcon = "/assets/social-icons/x.svg";

const ICONS: { [key: string]: { path: string; label: string } | undefined } = {
  youtube: { path: YoutubeIcon, label: "YouTube" },
  instagram: { path: InstagramIcon, label: "Instagram" },
  facebook: { path: FacebookIcon, label: "Facebook" },
  pinterest: { path: PinterestIcon, label: "Pinterest" },
  linkedin: { path: LinkedInIcon, label: "LinkedIn" },
  x: { path: XIcon, label: "X" },
};

export const FooterSocial: React.FC<{ data: FooterConfiguration["social"] }> = props => {
  return (
    <div css={socialStyles}>
      {props.data.map((social, idx) => {
        const icon = ICONS[social.icon.toLowerCase()] || null;

        return icon ? (
          <a
            target="_blank"
            rel="noopener noreferrer"
            key={JSON.stringify(social) + idx}
            href={social.link}
            className="u-flex"
          >
            <img src={icon.path} alt={icon.label} width={45} height={45} loading={"lazy"} />
          </a>
        ) : null;
      })}
    </div>
  );
};

const socialStyles = css`
  display: flex;
  gap: 20px;
  align-items: flex-end;
  height: 100%;

  ${CSS_MQ.atMostXs} {
    justify-content: space-between;
  }
`;
